module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/project-type-4-46813709a226775885a1d432b0ab567a.svg";